import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import toUrl from '../higherOrderFunction/toUrl';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private translations = new BehaviorSubject<{ [key in string]: string }>({});

  constructor(
    private http: HttpClient
  ) {
  }

  setTranslation(lang: string, country: string) {
    this.loadKeys(lang.toLowerCase(), country.toLowerCase()).subscribe((keys: {}) => {
      this.translations.next(keys);
    }, console.error);
  }

  getWordByKey(key: string): Observable<string> {
    return this.translations.pipe(
      map(translations => translations[key])
    );
  }

  loadKeys(lang: string, country: string): Observable<{ [key in string]: string }> {
    const url = toUrl(environment.links.translation, [lang, country]);
    return this.http.get<{ [key in string]: string }>(url);
  }
}
